import { z } from 'zod'

export const ADMINPERSONAMULTIAGENTPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminPersonaMultiAgentPostResponseSchema = z.unknown()
export type AdminPersonaMultiAgentPostResponse = z.infer<typeof adminPersonaMultiAgentPostResponseSchema>
